export * from 'server/models/CoordinationLocation';


// WEBPACK FOOTER //
// ./data/models/CoordinationLocation.ts